import { SDK } from "./sdk";
import type { SDKUserInfo } from "./sdk";
import type { SDKOptions } from "./state/sdk-options";

declare global {
  interface Window {
    FanFestSDK: SDK;
    __SDK_VERSION__: string | undefined;
  }
}

function main(): SDK {
  let sdk: SDK;

  if (window.FanFestSDK) {
    sdk = window.FanFestSDK;
  } else {
    sdk = new SDK();
    window.FanFestSDK = sdk;
  }

  if (!(sdk instanceof SDK)) {
    throw new Error("FanFestSDK: Invalid SDK instance");
  }

  return sdk;
}

export const FanFestSDK = main();
export const login = FanFestSDK.login;
export const logout = FanFestSDK.logout;
export const init = FanFestSDK.init;
export const enableTracking = FanFestSDK.enableTracking;
export const registerActionMapping = FanFestSDK.registerActionMapping;
export const trackEvent = FanFestSDK.trackEvent;
export const getUser = FanFestSDK.getUser;

export const version = window.__SDK_VERSION__ || "unknown";

export type { SDKOptions as FanFestInitOptions, SDKUserInfo };
